import { Box } from '@mui/material';
import CustomLoader from 'components/shared/CustomLoader/CustomLoader';
import { useParams } from 'react-router-dom';
import CompanyDetail from './CompanyDetail';
import OrganizationChart from './OrganizationChart';
import RecentNews from './RecentNews';
import SimilarCompanies from './SimilarCompanies';
import { useBusinessIntel } from './useCompanyIntel';

const Overview = () => {
  const { id } = useParams();
  const { data, loading } = useBusinessIntel(id ?? '');

  if (loading) return <CustomLoader open />;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: '20px', xl: '32px' },
        height: 'calc(100vh - 310px)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 2,
          overflowY: 'scroll',
        }}
      >
        <CompanyDetail data={data.companyDetails ?? {}} />
        <OrganizationChart data={data.orgChart} />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', flex: 1 }}>
        <RecentNews data={data.recentNews} />
        <SimilarCompanies data={data.similarCompanies} />
      </Box>
    </Box>
  );
};

export default Overview;
